import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export interface Company {
  _id: string;
  name: string;
}

interface OrderCompany {
  _id: string;
  name: string;
}

interface OrderItem {
  company?: OrderCompany;
}

export async function getCompanies(): Promise<Company[]> {
  try {
    // Fetch orders to extract companies from them
    const response = await axiosInstance.get(`${config.apiUrl}/orders?limit=100`);
    const orders: OrderItem[] = response.data.data;
    
    // Extract unique companies from orders
    const companiesMap = new Map<string, Company>();
    
    orders.forEach((order) => {
      if (order.company && order.company._id && order.company.name) {
        companiesMap.set(order.company._id, {
          _id: order.company._id,
          name: order.company.name,
        });
      }
    });
    
    // Convert map to array and sort by name
    const companies = Array.from(companiesMap.values()).sort((a, b) => 
      a.name.localeCompare(b.name)
    );
    
    return companies;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error fetching companies"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}